import { useState } from "react";
import Logo from "../static/LogoGT.svg";
import Phone from "../static/Phone.svg";
import RT from "../static/Rutube.svg";
import Vk from "../static/VK.svg";
import TG from "../static/Telegram.svg";
import { Link } from "react-router-dom";
import "./app-header.css";
import { Row, Col, Typography, Space, Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import HeaderSearch from "../header-search";
import CallBackButton from "../call-back-button/call-back-button";
import SiteMenu from "../site-menu";
import { CONTACT_DEFAULTS } from "../../constants";
import { useMediaQuery } from "../../hooks/useMediaQuery";

function AppHeader() {
  const onMenuClick = () => setVisible(false);

  const [visible, setVisible] = useState(false);
  const isMobileSm = useMediaQuery("sm");
  const isMobileXl = useMediaQuery("xl");
  const isTabletXxl = useMediaQuery("xxl");

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <>
      {isMobileSm ? (
        <div className="header content">
          <Row>
            <Col
              span={7}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Link to="/" className="header__logo-link">
                <img
                  src={Logo}
                  className="header__logo"
                  alt="Логотип General Trucks"
                  loading="lazy"
                />
              </Link>
            </Col>

            <Col span={1}></Col>

            <Col
              span={12}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyItems: "center",
                  }}
                  className="header__phone"
                >
                  <Space>
                    <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                    <Typography className="call-now">
                      <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                        {CONTACT_DEFAULTS.MAIN_PHONE}
                      </a>
                    </Typography>
                  </Space>
                </Col>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <HeaderSearch />
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
            <Col
              span={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
                justifyContent: "end",
              }}
            >
              <Button
                type="primary"
                onClick={showDrawer}
                aria-label="Открыть меню"
                aria-expanded={visible}
                className="button__menu"
                icon={<MenuOutlined />}
              />
            </Col>
            <Drawer
              title="Меню"
              placement="right"
              closable
              rootClassName="site-drawer"
              onClose={onClose}
              open={visible}
            >
              <Row>
                <Col span={24}>
                  <SiteMenu
                    mode="vertical"
                    onItemClick={(e) => {
                      onMenuClick(e);
                      onClose();
                    }}
                  />
                </Col>
                <Col span={24}>
                  <CallBackButton />
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    minWidth: "220px",
                  }}
                  className={"footer__phone"}
                >
                  <Space>
                    <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                    <Typography className="footer-call-now">
                      <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                        {CONTACT_DEFAULTS.MAIN_PHONE}
                      </a>
                    </Typography>
                  </Space>
                </Col>
                <Col
                  span={10}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: "100%",
                    flex: "none",
                  }}
                  className={"socsety_mobile"}
                >
                  <Space>
                    <Link to={CONTACT_DEFAULTS.RT} target="_blank">
                      <img
                        src={RT}
                        alt="RuTube"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.VK} target="_blank">
                      <img src={Vk} alt="VK" className="icon" loading="lazy" />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.TG} target="_blank">
                      <img
                        src={TG}
                        alt="Telegram"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                  </Space>
                </Col>
              </Row>
            </Drawer>
          </Row>
        </div>
      ) : isMobileXl ? (
        <div className="header content">
          <Row>
            <Col
              span={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Link to="/" className="header__logo-link">
                <img
                  src={Logo}
                  className="header__logo"
                  alt="Логотип General Trucks"
                  loading="lazy"
                />
              </Link>
            </Col>
            <Col span={1}></Col>
            <Col
              span={12}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyItems: "center",
                  }}
                  className="header__phone"
                >
                  <Space>
                    <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                    <Typography className="call-now">
                      <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                        {CONTACT_DEFAULTS.MAIN_PHONE}
                      </a>
                    </Typography>
                  </Space>
                </Col>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <HeaderSearch />
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
            <Col
              span={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
                justifyContent: "end",
              }}
            >
              <Button
                type="primary"
                onClick={showDrawer}
                aria-label="Открыть меню"
                aria-expanded={visible}
                className="button__menu"
                icon={<MenuOutlined />}
              />
            </Col>
            <Drawer
              title="Меню"
              placement="right"
              closable
              rootClassName="site-drawer"
              onClose={onClose}
              open={visible}
            >
              <Row>
                <Col span={24}>
                  <SiteMenu
                    mode="vertical"
                    onItemClick={(e) => {
                      onMenuClick(e);
                      onClose();
                    }}
                  />
                </Col>
                <Col span={24}>
                  <CallBackButton />
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    minWidth: "220px",
                  }}
                  className={"footer__phone"}
                >
                  <Space>
                    <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                    <Typography className="footer-call-now">
                      <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                        {CONTACT_DEFAULTS.MAIN_PHONE}
                      </a>
                    </Typography>
                  </Space>
                </Col>
                <Col
                  span={10}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: "100%",
                    flex: "none",
                  }}
                  className={"socsety_mobile"}
                >
                  <Space>
                    <Link to={CONTACT_DEFAULTS.RT} target="_blank">
                      <img
                        src={RT}
                        alt="RuTube"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.VK} target="_blank">
                      <img src={Vk} alt="VK" className="icon" loading="lazy" />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.TG} target="_blank">
                      <img
                        src={TG}
                        alt="Telegram"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                  </Space>
                </Col>
              </Row>
            </Drawer>
          </Row>
        </div>
      ) : isTabletXxl ? (
        <div className="header content">
          <Row>
            <Col
              span={4}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Link to="/" className="header__logo-link">
                <img
                  src={Logo}
                  className="header__logo"
                  alt="Логотип General Trucks"
                  loading="lazy"
                />
              </Link>
            </Col>
            <Col span={1}></Col>
            <Col span={9}>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <HeaderSearch />
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
            <Col
              span={5}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Space>
                <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                <Typography className="call-now">
                  <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                    {CONTACT_DEFAULTS.MAIN_PHONE}
                  </a>
                </Typography>
              </Space>
            </Col>
            <Col span={1}></Col>
            <Col
              span={1}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Button
                type="primary"
                onClick={showDrawer}
                aria-label="Открыть меню"
                aria-expanded={visible}
                className="button__menu"
                icon={<MenuOutlined />}
              />
            </Col>
            <Drawer
              title="Меню"
              placement="right"
              closable
              rootClassName="site-drawer"
              onClose={onClose}
              open={visible}
            >
              <Row>
                <Col span={24}>
                  <SiteMenu
                    mode="vertical"
                    onItemClick={(e) => {
                      onMenuClick(e);
                      onClose();
                    }}
                  />
                </Col>
                <Col span={24}>
                  <CallBackButton />
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    minWidth: "220px",
                  }}
                  className={"footer__phone"}
                >
                  <Space>
                    <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                    <Typography className="footer-call-now">
                      <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                        {CONTACT_DEFAULTS.MAIN_PHONE}
                      </a>
                    </Typography>
                  </Space>
                </Col>
                <Col
                  span={10}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: "100%",
                    flex: "none",
                  }}
                >
                  <Space>
                    <Link to={CONTACT_DEFAULTS.RT} target="_blank">
                      <img
                        src={RT}
                        alt="RuTube"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.VK} target="_blank">
                      <img src={Vk} alt="VK" className="icon" loading="lazy" />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.TG} target="_blank">
                      <img
                        src={TG}
                        alt="Telegram"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                  </Space>
                </Col>
              </Row>
            </Drawer>
          </Row>
        </div>
      ) : (
        <div className="header content">
          <Row>
            <Col
              span={4}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Link to="/" className="header__logo-link">
                <img
                  src={Logo}
                  className="header__logo"
                  alt="Логотип General Trucks"
                  loading="lazy"
                />
              </Link>
            </Col>
            <Col span={1}></Col>
            <Col span={9}>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <SiteMenu className="app-menu" onItemClick={onMenuClick} />
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <HeaderSearch />
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
            <Col
              span={5}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
              className="call-back-block"
            >
              <Col
                span={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CallBackButton />
              </Col>
            </Col>
            <Col span={1}></Col>
            <Col
              span={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
              }}
            >
              <Space>
                <img src={Phone} alt="Телефон" width={35} loading="lazy" />
                <Typography className="call-now">
                  <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                    {CONTACT_DEFAULTS.MAIN_PHONE}
                  </a>
                </Typography>
              </Space>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
export default AppHeader;
